import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_3'

export const dataPointDefinition = {
  retracedId: 'are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_3',
  name: 'Are facility practices failing to comply with any legal requirements not covered elsewhere regarding Working Hours?',
  description:
    'Answer No if the facility is complying with all legal requirements not covered elsewhere regarding Working Hours. \r\r\n\r\r\nConsult applicable legal requirements.\r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wh-wor-10',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7160,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
